/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon32Regular = forwardRef('ArrowCollapseCHClosedIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12.94 18.475a3.5 3.5 0 0 0 0-4.95L4.706 5.293a1 1 0 0 0-1.414 1.414l8.232 8.232a1.5 1.5 0 0 1 0 2.122l-8.232 8.232a1 1 0 1 0 1.414 1.414l8.232-8.232Z" }),
        React.createElement("path", { d: "M19.06 18.475a3.5 3.5 0 0 1 0-4.95l8.233-8.232a1 1 0 1 1 1.414 1.414l-8.232 8.232a1.5 1.5 0 0 0 0 2.122l8.232 8.232a1 1 0 0 1-1.414 1.414l-8.232-8.232Z" })));
});
